function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Pin");

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  d: "M19,13a3,3,0,1,1-3-3A3,3,0,0,1,19,13Zm8,0c0,5.86-9.86,16.25-10.28,16.69a1,1,0,0,1-1.44,0C14.86,29.25,5,18.86,5,13a11,11,0,0,1,22,0Zm-6,0a5,5,0,1,0-5,5A5,5,0,0,0,21,13Z"
}));

var SvgLocate = function SvgLocate(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    fill: "#000000",
    viewBox: "0 0 32 32",
    x: "0px",
    y: "0px",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLocate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/locate.2f2e7f13.svg";
export { ForwardRef as ReactComponent };